const getters = {
  getShipmentIsFetching: (state) => state.isFetching,
  getAllToggleShipments2: (state) => {
    return state.toggleShipments
  },
  getShipmentsByDate: (state) => (dates = null) => {
    // console.log('state.shipmentsByDate', state.shipmentsByDate)
    // console.log('getter date', date)
    // console.log('state.shipmentsByDate[date]', state.shipmentsByDate[date])
    let result = {}
    for (let i = 0; i < dates.length; i++) {
      const date = dates[i]
      result[date] = state.shipmentsByDate[date]
    }

    return result
  },
  getShipmentResourceDetails: (state) => {
    return state.shipmentDetails != null ? state.shipmentDetails : null
  },
  getShipmentResourceDrops: (state) => {
    return state.shipmentDetails != null ? state.shipmentDetails.drops : null
  },
  getShipmentResourceSchedule: (state) => {
    return state.shipmentDetailsSchedule
  },
  getShipmentResourceDropsDetails: (state) => {
    return state.shipmentDetailsDrops
  },
  getHereMapObject: (state) => {
    return state.hereMapObject
  },
  getShipmentSchedule: (state) => {
    return state.shipmentSchedule
  },
  getIsShipmentDetails: (state) => {
    return state.isShipmentDetail
  },
  getShipmentFetchingError: (state) => {
    return state.shipmentFetchingError
  },
  getShipmentAssignDriverList: (state) => {
    return state.assignDriverList
  },
  getShipmentAssignVehicleList: (state) => {
    return state.assignVehicleList
  },
  getShipmentUnitsLabels: (state) => (locationID) => {
    const location = state.shipmentLocations[locationID]
    if (location != null) {
      if (location.drops != null) {
        const labels = location.drops.map((drop) => {
          return drop.unitsCount.map((unitCount) => {
            return { name: 'packages_type.' + unitCount.type, value: unitCount.count }
          })
        }).flat().reduce((labelsArray, type) => {
          const packageName = type.name
          const index = labelsArray.findIndex(({ name }) => name === packageName)
          if (index < 0) {
            labelsArray.push({ name: packageName, value: type.value })
          } else {
            labelsArray[index].value += type.value
          }
          return labelsArray
        }, [])
        return labels
      }
    }
    return []
  },
  getScheduleShipmentLocation: (state) => (locationID) => {
    if (state.shipmentLocations[locationID] != null) {
      return state.shipmentLocations[locationID]
    }
    return null
  },
  getScheduleShipmentAllLocations: (state) => {
    if (state.shipmentLocations != null) {
      return state.shipmentLocations
    }
    return null
  }
}

export default getters
